module.exports = __webpack_public_path__ + "static/katahira_house-76f34170deea1160eb39c1cb049baa7f.jpg";